import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0eed40ec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0eed40ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eed40ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eed40ec')) {
      api.createRecord('0eed40ec', component.options)
    } else {
      api.reload('0eed40ec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0eed40ec&scoped=true&", function () {
      api.rerender('0eed40ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wPGUbINmw0hH/JS/comp/PopupBox.vue"
export default component.exports